var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidebar" },
    [
      _c("div", { staticClass: "sidebar__logo" }, [_c("logotype")], 1),
      _vm._v(" "),
      _c(
        "md-list",
        {
          staticClass: "sidebar__menu",
          attrs: { "md-expand-single": _vm.expandSingle }
        },
        [
          _c(
            "md-list-item",
            { attrs: { "md-expand": "", "md-ripple": false } },
            [
              _c("md-icon", {
                attrs: { "md-src": "/static/img/dashboard_icon.svg" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "md-list-item-text" }, [
                _vm._v(_vm._s(_vm.i18n.lbl_dashboard()))
              ]),
              _vm._v(" "),
              _c(
                "md-list",
                { attrs: { slot: "md-expand" }, slot: "md-expand" },
                [
                  _c(
                    "md-list-item",
                    {
                      attrs: { "md-ripple": false, to: "/dashboard" },
                      on: { click: _vm.closeSidebar }
                    },
                    [
                      _c("md-icon", {
                        attrs: { "md-src": "/static/img/wallet_icon.svg" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-list-item-text" }, [
                        _vm._v(_vm._s(_vm.i18n.lbl_my_wallet()))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.config.FEATURE_FLAGS.history &&
                  _vm.accountTypeI !== _vm.ACCOUNT_TYPES.notVerified &&
                  _vm.accountState !== "pending"
                    ? _c(
                        "md-list-item",
                        {
                          attrs: { "md-ripple": false, to: "/history" },
                          on: { click: _vm.closeSidebar }
                        },
                        [
                          _c("md-icon", {
                            attrs: {
                              "md-src":
                                "/static/img/transaction_history_icon.svg"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-list-item-text" }, [
                            _vm._v(_vm._s(_vm.i18n.lbl_history()))
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.config.FEATURE_FLAGS.refundHistory && _vm.refundHistory
                    ? _c(
                        "md-list-item",
                        {
                          attrs: { "md-ripple": false, to: "/refund-history" },
                          on: { click: _vm.closeSidebar }
                        },
                        [
                          _c("md-icon", {
                            attrs: {
                              "md-src":
                                "/static/img/transaction_history_icon.svg"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-list-item-text" }, [
                            _vm._v(_vm._s(_vm.i18n.lbl_refund_history()))
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.accountTypeI !== _vm.ACCOUNT_TYPES.notVerified &&
          _vm.accountState !== "pending"
            ? _c(
                "md-list-item",
                { attrs: { "md-expand": "", "md-ripple": false } },
                [
                  _c("md-icon", {
                    attrs: { "md-src": "/static/img/transactions_icon.svg" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-list-item-text" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_transactions()))
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-list",
                    { attrs: { slot: "md-expand" }, slot: "md-expand" },
                    [
                      _vm.config.FEATURE_FLAGS.cashbox && _vm.cashbox
                        ? _c(
                            "md-list-item",
                            {
                              attrs: { to: "/cashbox" },
                              on: { click: _vm.closeSidebar }
                            },
                            [
                              _c("md-icon", {
                                attrs: {
                                  "md-src": "/static/img/account-cash-icon.svg"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v(_vm._s(_vm.i18n.lbl_cashbox()))
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.config.FEATURE_FLAGS.widrawalRequest &&
                      _vm.widrawalRequest
                        ? _c(
                            "md-list-item",
                            {
                              attrs: {
                                "md-ripple": false,
                                to: "/withdrawal-req"
                              },
                              on: { click: _vm.closeSidebar }
                            },
                            [
                              _c("md-icon", {
                                attrs: {
                                  "md-src": "/static/img/account-cash-icon.svg"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v(_vm._s(_vm.i18n.lbl_withdrawal_req()))
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.config.FEATURE_FLAGS.topupBalance
                        ? _c(
                            "md-list-item",
                            {
                              attrs: {
                                "md-ripple": false,
                                to: "/topup-balance"
                              },
                              on: { click: _vm.closeSidebar }
                            },
                            [
                              _c("md-icon", {
                                attrs: {
                                  "md-src": "/static/img/top_up_icon.svg"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v(_vm._s(_vm.i18n.lbl_refill()))
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.config.FEATURE_FLAGS.withdrawal
                        ? _c(
                            "md-list-item",
                            {
                              attrs: { "md-ripple": false, to: "/withdrawal" },
                              on: { click: _vm.closeSidebar }
                            },
                            [
                              _c("md-icon", {
                                attrs: {
                                  "md-src": "/static/img/withdraw_icon.svg"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v(_vm._s(_vm.i18n.lbl_withdraw()))
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.config.FEATURE_FLAGS.transfers
                        ? _c(
                            "md-list-item",
                            {
                              attrs: { "md-ripple": false, to: "/transfers" },
                              on: { click: _vm.closeSidebar }
                            },
                            [
                              _c("md-icon", {
                                attrs: { "md-src": "/static/img/send_icon.svg" }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v(_vm._s(_vm.i18n.lbl_send()))
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.config.FEATURE_FLAGS.massTransfers
                        ? _c(
                            "md-list-item",
                            {
                              attrs: {
                                "md-ripple": false,
                                to: "/mass-transfers"
                              },
                              on: { click: _vm.closeSidebar }
                            },
                            [
                              _c("md-icon", {
                                attrs: {
                                  "md-src": "/static/img/masstransfer_icon.svg"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v(_vm._s(_vm.i18n.lbl_send_mass()))
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.systemAccount &&
          _vm.accountTypeI !== _vm.ACCOUNT_TYPES.notVerified &&
          _vm.accountState !== "pending"
            ? _c(
                "md-list-item",
                { attrs: { "md-expand": "", "md-ripple": false } },
                [
                  _c("md-icon", {
                    attrs: { "md-src": "/static/img/projects_icon.svg" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-list-item-text" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_projects()))
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-list",
                    { attrs: { slot: "md-expand" }, slot: "md-expand" },
                    [
                      _vm.config.FEATURE_FLAGS.saleCreation &&
                      _vm.accountTypeI === _vm.ACCOUNT_TYPES.syndicate
                        ? _c(
                            "md-list-item",
                            {
                              attrs: {
                                "md-ripple": false,
                                to: "/sale-creation"
                              },
                              on: { click: _vm.closeSidebar }
                            },
                            [
                              _c("md-icon", {
                                attrs: {
                                  "md-src":
                                    "/static/img/project_create_icon.svg"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v(_vm._s(_vm.i18n.lbl_create_sale()))
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.config.FEATURE_FLAGS.sales &&
                      _vm.accountTypeI === _vm.ACCOUNT_TYPES.syndicate
                        ? _c(
                            "md-list-item",
                            {
                              attrs: { "md-ripple": false, to: "/my-sales" },
                              on: { click: _vm.closeSidebar }
                            },
                            [
                              _c("md-icon", {
                                attrs: {
                                  "md-src": "/static/img/my_project_icon.svg"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v(_vm._s(_vm.i18n.lbl_my_funds()))
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.config.FEATURE_FLAGS.sales
                        ? _c(
                            "md-list-item",
                            {
                              attrs: { "md-ripple": false, to: "/sales" },
                              on: { click: _vm.closeSidebar }
                            },
                            [
                              _c("md-icon", {
                                attrs: {
                                  "md-src":
                                    "/static/img/explore_project_icon.svg"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v(_vm._s(_vm.i18n.lbl_explore_sales()))
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.config.FEATURE_FLAGS.portfolio && !_vm.systemAccount
                        ? _c(
                            "md-list-item",
                            {
                              attrs: { "md-ripple": false, to: "/portfolio" },
                              on: { click: _vm.closeSidebar }
                            },
                            [
                              _c("md-icon", {
                                attrs: {
                                  "md-src": "/static/img/investment_icon.svg"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v(
                                  _vm._s(_vm.i18n.lbl_investment_portfolio())
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.config.FEATURE_FLAGS.requests &&
                      _vm.accountTypeI === _vm.ACCOUNT_TYPES.syndicate &&
                      !_vm.systemAccount
                        ? _c(
                            "md-list-item",
                            {
                              attrs: { "md-ripple": false, to: "/requests" },
                              on: { click: _vm.closeSidebar }
                            },
                            [
                              _c("md-icon", {
                                attrs: {
                                  "md-src": "/static/img/requests_icon.svg"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v(_vm._s(_vm.i18n.lbl_requests()))
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.config.FEATURE_FLAGS.tokens
                        ? _c(
                            "md-list-item",
                            {
                              attrs: { to: "/tokens" },
                              on: { click: _vm.closeSidebar }
                            },
                            [
                              _c("md-icon", [_vm._v("toll")]),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v(_vm._s(_vm.i18n.lbl_explore_tokens()))
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.systemAccount && _vm.config.FEATURE_FLAGS.tokens
            ? _c(
                "md-list-item",
                { attrs: { to: "/tokens" }, on: { click: _vm.closeSidebar } },
                [
                  _c("md-icon", [_vm._v("toll")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-list-item-text" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_explore_tokens()))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.config.FEATURE_FLAGS.myFees &&
          _vm.accountTypeI !== _vm.ACCOUNT_TYPES.notVerified &&
          _vm.accountState !== "pending"
            ? _c(
                "md-list-item",
                {
                  attrs: { "md-ripple": false, to: "/fee" },
                  on: { click: _vm.closeSidebar }
                },
                [
                  _c("md-icon", {
                    attrs: { "md-src": "/static/img/fees_icon.svg" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-list-item-text" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_fee()))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.config.FEATURE_FLAGS.limits &&
          (_vm.accountTypeI === _vm.ACCOUNT_TYPES.syndicate ||
            _vm.accountTypeI === _vm.ACCOUNT_TYPES.general)
            ? _c(
                "md-list-item",
                {
                  attrs: { "md-ripple": false, to: "/limits" },
                  on: { click: _vm.closeSidebar }
                },
                [
                  _c("md-icon", {
                    attrs: { "md-src": "/static/img/limits_icon.svg" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-list-item-text" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_limits()))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.config.FEATURE_FLAGS.trade &&
          _vm.accountTypeI !== _vm.ACCOUNT_TYPES.notVerified &&
          _vm.accountState !== "pending"
            ? _c(
                "md-list-item",
                {
                  attrs: { "md-ripple": false, to: "/trade" },
                  on: { click: _vm.closeSidebar }
                },
                [
                  _c("md-icon", {
                    attrs: { "md-src": "/static/img/trade_icon.svg" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-list-item-text" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_trade()))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.accountState === "nil" || _vm.accountState === "rejected"
            ? [
                _c("md-divider"),
                _vm._v(" "),
                _vm.config.FEATURE_FLAGS.verification
                  ? _c(
                      "md-list-item",
                      {
                        attrs: { "md-ripple": false, to: "/verification" },
                        on: { click: _vm.closeSidebar }
                      },
                      [
                        _c("md-icon", [_vm._v("verified_user")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "md-list-item-text" }, [
                          _vm._v(_vm._s(_vm.i18n.lbl_verification()))
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.config.FEATURE_FLAGS.trade &&
          _vm.accountTypeI !== _vm.ACCOUNT_TYPES.notVerified &&
          _vm.accountState !== "pending"
            ? _c(
                "md-list-item",
                {
                  attrs: { to: "/exchange", "md-ripple": false },
                  on: { click: _vm.closeSidebar }
                },
                [
                  _c("md-icon", [_vm._v("autorenew")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-list-item-text" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_exchange()))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.systemAccount &&
          _vm.config.FEATURE_FLAGS.contracts &&
          _vm.accountTypeI !== _vm.ACCOUNT_TYPES.notVerified &&
          _vm.accountState !== "pending"
            ? _c(
                "md-list-item",
                {
                  attrs: { to: "/contracts", "md-ripple": false },
                  on: { click: _vm.closeSidebar }
                },
                [
                  _c("md-icon", [_vm._v("contact_mail")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-list-item-text" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_contracts()))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.config.FEATURE_FLAGS.settings
            ? _c(
                "md-list-item",
                {
                  attrs: { "md-ripple": false, to: "/settings" },
                  on: {
                    click: function($event) {
                      return _vm.closeSidebar()
                    }
                  }
                },
                [
                  _c("md-icon", {
                    attrs: { "md-src": "/static/img/settings_icon.svg" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-list-item-text" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_settings()))
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0664c383", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0664c383","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/navigation/Sidebar.vue
// module id = KSMH
// module chunks = 1